import { useLeaflet } from "react-leaflet";
import { connect } from "react-redux";
import { useEffect } from "react";
import L from "leaflet";
import startFlag from './start.png'
import finishFlag from './finish.png'

const MarkerError = (props) => {
    
    const { map } = useLeaflet();
    const drawImage = (image) => {
        var iconStart = L.icon({
          iconUrl: image,
          iconSize: [30, 30],
          iconAnchor:   [15  , 35],
          popupAnchor:  [0, -35]
        });
    return iconStart
}

//Rimozione Layer
const removeOldLayer = (string) => {
    map.eachLayer(element => {
      if ( element.options.nome === string ) {
        try {
          element.removeFrom(map) 
        }
        catch(e) { 
        }
      }
    });
  }

    useEffect(()=>{
       
        try { 
            if(props.pathData.paths.error.id == 404){
           // removeOldLayer("markerStart")
           
            const start = [props.markerStart2.markerStart2.lat,props.markerStart2.markerStart2.lng]
            
            const startMarker = L.marker(start,{icon: drawImage(startFlag),nome: "markerStart"})
            startMarker.addTo(map)
             
            
            }else{
               
            }
            //map.fitBounds([start,start], {maxZoom: 15});
        } catch (error) {
            
        }
       
    },[props.markerStart2])

    useEffect(()=>{
        try { 
            
        //removeOldLayer("markerEnd")
        if(props.pathData.paths.error.id == 404){
            
        const end = [props.markerEnd2.markerEnd2.lat,props.markerEnd2.markerEnd2.lng]
        const endMarker = L.marker(end,{icon: drawImage(finishFlag),nome: "markerEnd"})
        endMarker.addTo(map)
        }
        //map.fitBounds([end,end], {maxZoom: 15});
     } catch (error){

     }
    },[props.markerEnd2])
    return null;
}

const mapStateToProps = state => {
    return {
        markerStart: state.markerStart,
        markerEnd: state.markerEnd,
        markerError : state.markerError,
        pathData: state.path,
      indexSelected: state.index,
      markerStart2 : state.markerStart2,
      markerEnd2 : state.markerEnd2
        
    }
  }

export default connect(mapStateToProps)(MarkerError);